/**
 * AI seeding API (DEV-1354). Admin-only — server calls the Claude API
 * (web-grounded) and returns a new DRAFT chronicle + per-source reliability.
 */

import { apiFetch } from "./client";

export interface SeedSourceReliability {
  url: string | null;
  label: string | null;
  type: string | null;
  reliability: string | null;
  reliabilityRationale: string | null;
}

export interface SeedChronicleResponse {
  chronicleGuid: string;
  aiConfidence: string | null;
  intent: string | null;
  notes: string | null;
  sourceReliability: SeedSourceReliability[];
}

export interface SeedChronicleRequest {
  topic: string;
  /** "topic_tracker" | "project" */
  chronicleType: string;
  /** "general" | "problem" | "solution" */
  intent?: string;
  sourceUrls?: string[];
  model?: string;
}

export function seedChronicle(req: SeedChronicleRequest): Promise<SeedChronicleResponse> {
  return apiFetch<SeedChronicleResponse>("/api/ai/seed-chronicle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });
}
